import React, {useState, useEffect} from 'react';
import { Bot, LastMessage, TContact, getLastMessage, getTodayReport } from "../bot-loaders";
import { Loading } from '../components/Loading';
import { Column, Table } from '../table/Table';
import { formatDatetime } from 'simple-utils/dist/date-utils';
import { Modal } from '../components/Modal';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import { DateUtils } from 'simple-utils';
import { WhatsAppMarkdown } from '../whats-markdown/WhatsAppMarkdown';


function LastMessageModal({bot, to}:{bot:Bot, to:TContact}){
    const [loading, setLoading] = useState(true)
    const [lastMessage, setLastMessage] = useState<LastMessage>(null);

    useEffect(() => {
        (async function(){
            const m = await getLastMessage(bot, to.id);
            setLastMessage(m);
            setLoading(false);
        })();
    }, [])

    if(loading) return <Loading />

    if(!lastMessage) return <>Error Loading Message</>

    function getTime(time:number){
        var a = new Date();
        a.setTime(time * 1000)
        return DateUtils.formatDatetime(a);
    }

    return <>
        <div className=''>
            {
                lastMessage.body ? <WhatsAppMarkdown message={lastMessage.body} /> :
                <><b>Type: </b> {lastMessage.type}</>
            }
        </div>
        <hr />
        <p><span className="badge bg-info"><b>Enviado:</b> {getTime(lastMessage.timestamp)}</span></p>
    </>
}


export  function BotTodayReport({bot}:{bot:Bot}){
    const [loading, setLoading] = useState(true)
    const [contacts, setContacts] = useState<TContact[]>(null);
    const [viewContact, setViewContact] = useState<TContact>(null);

    useEffect(() => {
        (async function(){
            const list = await getTodayReport(bot);
            list.sort((a, b) => -1 * (a.time.getTime() - b.time.getTime()))
            setContacts(list);
            setLoading(false);
        })();
    }, [])

    if(loading) return <Loading />

    if(!contacts.length)
        return <p>Não houve interações hoje.</p>
    
    const columns:Column<TContact>[] = [
        { id: "phone", label: "Telefone", render:  c => c.id},
        { id: "name", label: "Nome", render:  c => c.name || ""},
        { id: "time", label: "Hora", render:  c => formatDatetime(c.time as Date)}
    ]

    return  <>
        <div className='mb-4'>Número de contatos hoje <b>{contacts.length}</b></div>
        <div className='table-view' style={{maxHeight: "calc(100vh - 312px)", position: "relative", overflow:"auto"}}>
            <Table columns={columns} data={contacts} onClick={(item) => setViewContact(item)} />
        </div>
        {viewContact && <Modal title={viewContact.name || viewContact.id} onHide={() => setViewContact(null)}><LastMessageModal bot={bot} to={viewContact} /></Modal>}
    </>
}